module.exports = __webpack_public_path__ + "6010b2828647aec66a0ba938b31bcb8f.svg";